import React, { useEffect, useState } from 'react';
import axios from 'axios';

import "./Invoices.scss"
import moment from 'moment';
import arrowTitle from '../../assets/arrow_rigth.svg'
import arrowBtn from '../../assets/arrow_bottom.svg'
import lineBlue from '../../assets/bg_line-100.jpg'
import Table from '../../components/table/Table';
import Pager from '../../components/pager/Pager';
import Backdrop from "../../components/backdrop/Backdrop"
import { useDispatch, useSelector } from 'react-redux';
import { getAllBillingsThunk } from '../../redux/billings/thunks';
import { getAccountThunk } from '../../redux/user/thunks';
import { changeLoading } from '../../redux/billings/billingsSlice';
import {API_URL, MERCADOPAGO_URL} from '../../config/'
/*
import BillingSection from '../../components/billing/BillingSection'
import BillingTable from '../../components/billing/BillingTable'*/

const PAGE_SIZE = 10;

export default function Invoices() {
    const dispatch = useDispatch()
    let invoicesSubscription = useSelector(state => state.billings.invoicesSubscription);
    let user = useSelector(state => state.user.data);
    let token = useSelector(state => state.auth.token);
    let invoicesActivities = useSelector(state => state.billings.invoicesActivities);
    let loading = useSelector(state => state.billings.loading);
    let message = useSelector(state => state.billings.message);
    let mpSubscription = useSelector(state => state.user.mpSubscription);
    const [loadingDownload, setLoadingDownload] = useState(false)
    const [downloadError, setDownloadError] = useState(null)
    const [subscriptionPage, setSubscriptionPage] = useState(1)
    const [activitiesPage, setActivitiesPage] = useState(1)

    const isCredit = user.subscription?.type === 'credit';
    const lastChargedAmount = mpSubscription?.chargedAmount ?? user.subscription?.chargedAmount;
    const lastCharged = mpSubscription?.lastCharged || user.subscription?.lastCharged;
    const nextDate = isCredit ? mpSubscription?.nextPaymentDate : user.subscription?.dueDate;
    const mpLink = mpSubscription?.link || user.subscription?.link;
    // en produccion MERCADOPAGO_URL es un path propio (/external/mercadopago/)
    // que el server proxea, para no linkear directo al dominio de MP
    const mercadopago_url = mpLink ? MERCADOPAGO_URL + mpLink.replace('https://www.mercadopago.com.ar/', '') : null;

    useEffect(() => {
        dispatch(getAllBillingsThunk())
        dispatch(getAccountThunk())
    }, [])

    const status_translation = (status) => {
        let statusEnEspañol;

        switch (status) {
          case 'nonMember':
            statusEnEspañol = 'No miembro';
            break;
          case 'pending':
            statusEnEspañol = 'Pendiente de pago. Su pago todavía no fue procesado';
            break;
          case 'authorized':
            statusEnEspañol = 'Miembro con cuota al día';
            break;
          case 'paused':
            statusEnEspañol = 'Membresía pausada por falta de pago';
            break;
          case 'cancelled':
            statusEnEspañol = 'Membresía cancelada';
            break;
          case 'debtor':
            statusEnEspañol = 'Deudor';
            break;
          case 'free':
            statusEnEspañol = 'Membresía gratuita';
            break;
          case 'review':
            statusEnEspañol = 'Membresia en revisión';
            break;
          default:
            statusEnEspañol = 'Estado desconocido';
        }
      
        return statusEnEspañol;
      }
    

    const downloadPdf = async (billingId) => {
        setLoadingDownload(true)
        setDownloadError(null)
        try {
            const response = await axios.get(`${API_URL}/billing/downloadInvoice/${billingId}`, {
                headers: { 'access-token': localStorage.getItem('token') },
                responseType: 'arraybuffer'
            });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `facturaAaoc.pdf`;
            a.click();
        } catch (e) {
            setDownloadError('No se pudo descargar la factura. Por favor intenta nuevamente en unos minutos.');
        }
        setLoadingDownload(false)
    }


    if (loading) {
        return <Backdrop show={loading} />
    }

    return (
        <main id='billing'>
            {
                user?.membershipStatus === 'authorized'
                    ?
                    <section className='section sectionSecondary bg-blue'>
                        <div className="columns is-multiline">
                            <div className="column is-12">
                                <h1 className="titleProp">
                                    <div className='text'>
                                        <span className='title-border-white'>DATOS </span>
                                        <br />
                                        <span className='title-bold-white'>DE FACTURACIÓN </span><br />
                                        <img src={lineBlue} alt="" />
                                    </div>
                                    <div className='btn-title'>
                                        <img src={arrowBtn} alt="" />
                                    </div>
                                </h1>
                            </div>

                            <div className="column is-12 ">
                                <p className='white subtitle is-4'>
                                    Tipo de membresía:  <span className='yelow' >
                                        {status_translation(user.membershipStatus)}
                                    </span>
                                </p>
                                {(user.subscription?.type === 'credit' || user.subscription?.type === 'wire') &&
                                <>
                                    <p className='white subtitle is-4'>
                                        Tipo de Pago:  <span >
                                           {isCredit ? 'Mercado Pago' : 'Transferencia Bancaria'}
                                        </span>
                                    </p>

                                    <p className='white subtitle is-4'>
                                        Monto de último pago: <span >
                                            {lastChargedAmount ? `${lastChargedAmount}` : 'No se ha efectuado ningún pago'}
                                        </span>
                                    </p>
                                    <p className='white subtitle is-4'>
                                        Fecha de última cobro efectuado: <span>
                                            {lastCharged ? moment(lastCharged).format('DD/MM/YYYY') : 'No se ha efectuado ningún pago'}
                                        </span>
                                    </p>
                                    <p className='white subtitle is-4'>
                                        {isCredit ? 'Próximo intento de cobro' : 'Próxima fecha de pago'}: <span >
                                            {nextDate ? moment(nextDate).format('DD/MM/YYYY') : 'No se ha efectuado ningún pago'}
                                        </span>
                                    </p>
                                  {isCredit && mercadopago_url ?
                                    <p className='white subtitle is-4'>
                                        <a href={mercadopago_url} style={{color: 'white'}}>Cambiar metodo de pago, modificar, o cancelar subscripción</a>
                                    </p> : null
                                    }
                                </>
                                }
                            </div>

                   

                        </div>
                    </section>
                    :
                    null
                  
            }
            {
                invoicesSubscription && invoicesSubscription.length
                    ?
                    <section className='section sectionTertiary'>
                        <div className="columns is-multiline">
                            <div className="column is-12">
                                <h1 className="titleProp">
                                    <div className='text'>
                                        <span className='title-border-blue'>FACTURAS </span>
                                        <br />
                                        <span className='title-bold-blue'>DE <span className='textLineYelow'>SUSCRIPCIONES</span></span><br />
                                    </div>
                                </h1>
                            </div>
                            <div className=" column is-12 table-container">
                                <Table
                                    vouchers={invoicesSubscription.slice((subscriptionPage - 1) * PAGE_SIZE, subscriptionPage * PAGE_SIZE)}
                                    downloadPdf={downloadPdf}
                                />
                                <Pager
                                    page={subscriptionPage}
                                    totalPages={Math.ceil(invoicesSubscription.length / PAGE_SIZE)}
                                    onChange={setSubscriptionPage}
                                />
                            </div>
                        </div>
                    </section>
                    :
                    null
            }
            {
                (invoicesActivities && invoicesActivities.length)
                    ?
                    <section className='section sectionTertiary'>
                        <div className="columns is-multiline">
                            <div className="column is-12">
                                <h1 className="titleProp">
                                    <div className='text'>
                                        <span className='title-border-blue'>FACTURAS </span>
                                        <br />
                                        <span className='title-bold-blue'>DE <span className='textLineYelow'>ACTIVIDADES</span></span><br />
                                    </div>
                                </h1>
                            </div>
                            <div className=" column is-12 table-container">
                                <Table
                                    vouchers={invoicesActivities.slice((activitiesPage - 1) * PAGE_SIZE, activitiesPage * PAGE_SIZE)}
                                    downloadPdf={downloadPdf}
                                />
                                <Pager
                                    page={activitiesPage}
                                    totalPages={Math.ceil(invoicesActivities.length / PAGE_SIZE)}
                                    onChange={setActivitiesPage}
                                />
                            </div>
                        </div>
                    </section>
                    :
                    null
            }
            {
                downloadError
                    ?
                    <div className="titleProp" style={{fontSize: '1.2rem', textAlign: 'center', color: 'red', padding: '1rem'}}>
                        {downloadError}
                    </div>
                    :
                    null
            }
            {
                (!invoicesActivities.length && !invoicesSubscription.length)
                    ?
                    <div className="titleProp" style={{fontSize:'3.4rem', lineHeight:'3.4rem', paddingTop:  user?.membershipStatus !== 'authorized' ? '10rem' : '4rem', paddingBottom: '4rem'}}>
                    <div className={'title-bold-blue text-center'}> 
                        <p>NO SE ENCONTRARON</p>
                        <p>FACTURAS GENERADAS</p>
                    </div>
                    </div>
                    :
                    null
            }
            <Backdrop show={loadingDownload} />
        </main>
    )
}